<template>
	<div style="height: 100%;">
		<code-login ref="myCodeLogin" @update-page="updatePage"></code-login>
		<head-top head-title="文武教师" goBack="true"></head-top>
		<div class="top">
			<div class="flex_b curriculum_title" style="flex-direction: column;">
				<div class="color_a ellipsis_1 font_size_a" style="width: 100%;">
					{{skuName?skuName:name}}
				</div>
				<!-- 课程有效期 -->
				<div v-if="hasExpired" class="color_d font_size_e" style="width: 100%;">
					此课程有效期至{{(expiredTime).substr(0, 10)}}
				</div>
			</div>

			<div v-if="topShow=='video'">
				<div class="main_a bg_d rowAndColCenter">
					<div class="main_a">
						<video-player class="video-player vjs-custom-skin" ref="videoPlayer" webkit-playsinline="true" x-webkit-airplay="true"
						 @play="onPlayerPlay($event)" @pause="onPlayerPause($event)" @timeupdate="onPlayerTimeupdate($event)" @ready="playerReadied"
						 playsinline :options="playerOptions">
						</video-player>
					</div>
				</div>
			</div>

			<div v-if="topShow=='image'" class="main_a">
				<img :src='coverURL' v-if="coverURL" class="main_a" />
			</div>

			<div class="border_top_a bg_a">
				<div class="flex_b color_e font_size_c fw" style="width: 100%;">
					<div class="tab_item" :class="[tab_index==0?'active':'']" @click="choose_tab(0)">
						课程详情
					</div>
					<div class="tab_item" :class="[tab_index==2?'active':'']" @click="choose_tab(2)">
						教师介绍
					</div>
					<div class="tab_item" :class="[tab_index==3?'active':'']" @click="choose_tab(3)">
						直播章节
					</div>
					<div class="tab_item" :class="[tab_index==4?'active':'']" @click="choose_tab(4)">
						回放章节
					</div>
				</div>
			</div>
		</div>
		<!-- tab对应内容 -->
		<div class="tab_content">
			<!-- 课程详情 -->
			<div v-if="tab_index==0" v-html="info" class="curriculum_details color_a font_size_c"></div>

			<!-- 教师介绍 -->
			<div v-else-if="tab_index==2" class="cell_a">
				<div v-for="item in curriculumTeachers" :key='item.id' class="curriculum_item">
					<div class="flex_a">
						<img :src="resourceDomain + item.pic" v-if="item.pic" class="teachercell"></img>
						<div class="color_a font_size_c fw">{{item.name}}</div>
					</div>
					<div class="font_size_b color_f teacherbrief">
						{{item.brief}}
					</div>
				</div>
			</div>

			<!--直播章节 -->
			<div class="cell_a" v-else-if="tab_index==3">
				<div v-if="liveChapterList.length>0">
					<div class="syllabu_item font_size_b " :style="{'color':item.color}" @click="toplay(item.free,item.id,index,item.type,item.chapterName,item.videoId)"
					 v-for="(item,index) in liveChapterList" :key='index'>
						<img :src='resourceDomain+"static/icon/free_a.png"' v-if="item.free" class="freeIcon" />
						<div class="font_size_b ellipsis_1 margin_bottom_a3" style="width: 100%;">
							{{item.chapterName}}
						</div>

						<div class="flex_c">
							<div class="font_size_e">
								<!-- 直播未开始 -->
								<div v-if="item.type==2&&item.extendStatus==2" class="color_d">
									{{item.broadcastStartTime}}开始
								</div>
								<!-- 直播中 -->
								<div v-if="item.type==2&&item.extendStatus==1" class="color_c flex_a">
									<img :src='resourceDomain+"static/icon/living_a.gif"' class="livingIcon" />
									<div>直播中</div>
								</div>
							</div>
							<div v-if="item.wapChapterAttachmentVos.length>0">
								<div class="tips_a downbtn font_size_d" @click.stop="toshowFiles(item.wapChapterAttachmentVos,item.free)">
									选择附件，点击下载
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-else class="color_e font_size_c" style="text-align: center;">
					暂无直播
				</div>
			</div>

			<!-- 回放章节 -->
			<div class="cell_a" v-else-if="tab_index==4">
				<div v-if="playbackChapterList.length>0">
					<div class="syllabu_item font_size_b " :style="{'color':item.color}" @click="toplay(item.free,item.id,index,item.type,item.chapterName,item.videoId)"
					 v-for="(item,index) in playbackChapterList" :key='index'>
						<img :src='resourceDomain+"static/icon/free_a.png"' v-if="item.free" class="freeIcon" />
						<div class="font_size_b ellipsis_1 margin_bottom_a3" style="width: 100%;">
							{{item.chapterName}}
						</div>

						<div class="flex_c">
							<div class="font_size_e">
								<!-- 预设置回放 -->
								<div v-if="item.type==1&&!item.videoId" class="color_d">
									预计{{(item.canWatchTime).substr(0, 10)}}可观看
								</div>
								<!-- 正常回放 -->
								<div v-else class="color_a">
									时长：{{item.playTime}}
								</div>
							</div>
							<div v-if="item.wapChapterAttachmentVos.length>0">
								<div class="tips_a downbtn font_size_d" @click.stop="toshowFiles(item.wapChapterAttachmentVos,item.free)">
									选择附件，点击下载
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-else class="color_e font_size_c" style="text-align: center;">
					暂无回放
				</div>
			</div>
		</div>
		<!-- 显示附件列表的弹窗 -->
		<van-action-sheet v-model="showFiles" :actions="skuFiles" cancel-text="取消" close-on-click-action @select="onSelectFiles" />
		<!-- tab内容结束 -->
	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'
	import api from '@/apis/api'
	import util from "@/common/tool";
	import {
		mapGetters,
		mapActions
	} from 'vuex';
	import Vue from 'vue';
	export default {
		name: 'CurriculumStudy',
		components: {
			headTop: headTop
		},
		data() {
			return {
				liveChapterList: [], //直播章节
				playbackChapterList: [], //回放章节
				skuFiles: [], //对应sku下的附件列表
				showFiles: false, //对应sku下的附件列表的选择弹窗
				curriculumId: undefined,
				chapterId: undefined,
				skuId: undefined,
				tab_index: 0,
				coverURL: undefined,
				info: "",
				topShow: undefined,
				buyOrNot: undefined, //是否购买，true购买了
				curriculumTeachers: [], //老师列表
				name: "", //课程名
				skuName: "", //sku名
				hasExpired: false, //是否有过期时间
				expiredTime: "", //过期时间
				classType: 1, //1 大班课 2小班课
				resourceDomain: api.resourceDomain,
				// 视频播放
				playerOptions: {
					playbackRates: [0.5, 1.0,1.25, 1.5, 2.0], //可选择的播放速度
					autoplay: false, //如果true,浏览器准备好时开始回放。
					muted: false, // 默认情况下将会消除任何音频。
					loop: false, // 视频一结束就重新开始。
					preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
					language: 'zh-CN',
					aspectRatio: '2:1', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
					fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
					sources: [{
						type: "",
						src: '' //url地址
					}],
					poster: "", //你的封面地址
					// width: document.documentElement.clientWidth,
					notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
					controlBar: {
						timeDivider: true, //当前时间和持续时间的分隔符
						durationDisplay: true, //显示持续时间
						remainingTimeDisplay: false, //是否显示剩余时间功能
						fullscreenToggle: true //全屏按钮
					}
				},
				totalTime: 0, // 观看总时间，ms
				interval: {},
				intervalDur: 1000,
				nowTime: null,
				initialTime: 0, // 指定视频初始播放位置
				playPosition: 0, // 视频播放进度
			}
		},
		//导航离开该组件的对应路由时调用
		beforeRouteLeave(to, from, next) {
			clearInterval(this.interval)
			//保存观看记录
			this.insertChapterViewingRecord()
			next()
		},
		created() {
			this.curriculumId = this.$route.query.curriculumId // 课程id
			this.skuId = this.$route.query.skuId
			this.chapterId = this.$route.query.chapterId
			if(this.chapterId){
				this.tab_index = this.$route.query.tab_index
			}
			this.updatePage()
		},

		activated() {},

		methods: {
			...mapActions("userModule", ["SET_OPENID"]),
			
			// 调用组件中的登录成功里的自定义的更新数据事件
						updatePage() {
							/*
							1.详情页点击观看按钮、我的课程点击、观看历史过来的，不带章节id
							（
							没带章节id。然后去查播放历史记录。
							之前有看过（r.data.bizUserViewingRecord有数据）就继承之前看到的那个章节的id，再根据isLiveChapter来激活tab，false=回放=4，true=直播=3；
							如果没有看过（r.data.bizUserViewingRecord==null），章节id就undefined,tab_index激活0=详情。
							）
							
							2.详情页点某个章节的id进来的就会带章节id过来，这个时候再去取带过来的tab_index,3=直播，4=回放
							*/
							var chapterId = this.chapterId
							if (!chapterId) {
								// 查询课程播放进度
								api.get('/curriculum/getBizUserViewingRecordByCurriculumId', {
									curriculumId: this.curriculumId,
									skuId: this.skuId
								}).then(r => {
									if (r.data.bizUserViewingRecord != null) {
										this.chapterId = r.data.bizUserViewingRecord.curriculumChapterId
										this.tab_index = r.data.isLiveChapter ? 3 : 4
									} else {
										this.chapterId = undefined
										this.tab_index = 0
									}
								}).finally(() => {
									this.curriculumPlayPage()
								})
							} else {
								this.curriculumPlayPage()
							}
							// 绑定beforeunload事件和unload事件
							window.addEventListener('beforeunload', this.leaveConfirm)
						},

			// 监听页面刷新
			leaveConfirm(e) {
				e = e || window.event
				if (e) {
					e.returnValue = '关闭提示'
				}

				clearInterval(this.interval)
				//保存观看记录
				this.insertChapterViewingRecord()
				return '关闭提示'
			},

			// 获取课程章节目录,详情,附件
			curriculumPlayPage() {
				var curriculumId = this.curriculumId,
					chapterId = this.chapterId
				this.$toast.loading({
					overlay: true,
					message: '加载中...',
					duration: 0
				})

				api.get('/curriculum/toCurriculumPlayPage', {
					curriculumId: curriculumId,
					skuId: this.skuId
				}).then(res => {
					this.$toast.clear()
					if (res.success) {
						if(res.data.offStatus){
							this.$dialog.alert({
								title: '提示',
							  message: '该课程已下架',
							}).then(() => {
							this.$router.go(-1)
							});
							return false
						}
						var liveChapterList = res.data.liveChapterList,
							playbackChapterList = res.data.playbackChapterList,
							coverURL = res.data.img,
							info = res.data.content
						/*
						1.如果没有章节id(从详情页或者我的课程过来，且没有观看过),不激活章节
						2.如果有章节id(从详情页点击某个章节进来的，已在详情页做了购买、预设置拦截；或者有过观看记录，接着之前的记录来)，选中的章节id和tab(3=直播，4=回放)激活
						*/
						if (!chapterId) {
							this.topShow = "image"
						} else {
							if (this.tab_index == 3) {
								// 直播
								var a = liveChapterList.findIndex(item => item.id == this.chapterId)
								liveChapterList[a].color = "#38F"
								this.liveChapterList = liveChapterList
								this.topShow = "image"
							} else {
								// 回放
								var b = playbackChapterList.findIndex(item => item.id == this.chapterId)
								playbackChapterList[b].color = "#38F"
								// 如果直接用网址进来,但其实是没有购买的
								if(res.data.buyOrNot){
									if (playbackChapterList[b].type == 1) { //点播回放
										this.topShow = "video"
										this.getPlayInfoByChapterId()
									} else { //百家云回放
										this.topShow = "image"
									}
								}else{
									this.topShow = "image"
								}
								
								
							}
						}
						this.coverURL = this.resourceDomain + coverURL
						this.buyOrNot = res.data.buyOrNot
						this.curriculumTeachers = res.data.curriculumTeachers
						this.liveChapterList = liveChapterList
						this.playbackChapterList = playbackChapterList
						this.name = res.data.name
						this.info = info
						this.skuName = res.data.skuName
						this.classType = res.data.classType
						this.hasExpired = res.data.hasExpired
						this.expiredTime = res.data.expiredTime
					} else {
						this.$toast(res.message);
					}
				})
			},

			// 获取视频
			getPlayInfoByChapterId() {
				var chapterId = this.chapterId

				api.get('/curriculum/getPlayInfoByChapterId', {
					id: chapterId,
					skuId: this.skuId,
					curriculumId: this.curriculumId
				}).then(res => {
					this.$toast.clear()
					if (res.success) {
						console.log(res.data, "-----getPlayInfoByChapterId------")
						this.playerOptions.poster = res.data.coverURL
						this.playerOptions.sources[0].src = res.data.playURL
						this.playPosition = res.data.playPosition
					} else {
						this.$toast(res.message)
					}
				})
			},

			// 点击章节
			toplay(free, id, index, type, chapterName, videoId) {
				// 定时器清除
				clearInterval(this.interval)

				var buyOrNot = this.buyOrNot,
					liveChapterList = this.liveChapterList,
					playbackChapterList = this.playbackChapterList,
					tab_index = this.tab_index //3=直播，4=回放

				for (let liveItem of liveChapterList) {
					liveItem.color = "#000"
				}
				for (let backItem of playbackChapterList) {
					backItem.color = "#000"
				}

				/*是否购买
				true购买了
					直播
						直播结束，跳百家云回放页面。
						正在直播，跳百家云直播页。（大班课直接跳，小班课提示后跳）
						直播还没开始，超30分钟不跳，30分钟内跳百家云直播页。（大班课直接跳，小班课提示后跳）
					点播
						如果是预设置的，跳提示
						如果不是预设置的，是百家云就跳百家云页面，不是百家云就获取视频信息
					
				false没有购买
					免费的
						直播
							直播结束，跳百家云回放页面。
							正在直播，跳百家云直播页。（大班课直接跳，小班课提示后跳）
							直播还没开始，超30分钟不跳，30分钟内跳百家云直播页。（大班课直接跳，小班课提示后跳）
						点播
							如果是预设置的，跳提示
							如果不是预设置的，是百家云就跳百家云页面，不是百家云就获取视频信息
					不免费的：提示购买
				*/
				if (this.buyOrNot) {
					if (tab_index == 3) { //直播
						liveChapterList[index].color = "#38F"
						this.liveChapterList = liveChapterList
						this.topShow = "image"
						this.toBjyLivePage(id, liveChapterList[index].extendStatus, chapterName, liveChapterList[index].leftTimeStatus)
					} else { //回放
						if (type == 1 && !videoId) { //预设置
							this.$toast('该章节暂不可观看')
							playbackChapterList[index].color = "#000"
							this.playbackChapterList = playbackChapterList
							this.topShow = "image"
						} else if (type == 1 && videoId) { //正常点播
							playbackChapterList[index].color = "#38F"
							this.playbackChapterList = playbackChapterList
							this.topShow = "video"
							this.chapterId = id
							this.getPlayInfoByChapterId()
						} else if (type == 2) { //百家云回放
							playbackChapterList[index].color = "#38F"
							this.playbackChapterList = playbackChapterList
							this.topShow = "image"
							this.$router.push({
								'path': '/playback',
								query: {
									id: id,
									skuId: this.skuId,
									headtitle: chapterName,
									curriculumId: this.curriculumId
								}
							})
						}
					}
				} else {
					if (free) {
						if (tab_index == 3) {
							liveChapterList[index].color = "#38F"
							this.liveChapterList = liveChapterList
							this.topShow = "image"
							this.toBjyLivePage(id, liveChapterList[index].extendStatus, chapterName, liveChapterList[index].leftTimeStatus)
						} else {
							if (type == 1 && !videoId) {
								this.$toast('该章节暂不可观看')
								playbackChapterList[index].color = "#000"
								this.playbackChapterList = playbackChapterList
								this.topShow = "image"
							} else if (type == 1 && videoId) {
								playbackChapterList[index].color = "#38F"
								this.playbackChapterList = playbackChapterList
								this.topShow = "video"
								this.chapterId = id
								this.getPlayInfoByChapterId()
							} else if (type == 2) {
								playbackChapterList[index].color = "#38F"
								this.playbackChapterList = playbackChapterList
								this.topShow = "image"
								this.$router.push({
									'path': '/playback',
									query: {
										id: id,
										skuId: this.skuId,
										headtitle: chapterName,
										curriculumId: this.curriculumId
									}
								})
							}
						}
					} else {
						this.$dialog.alert({
							title: '提示',
							message: '该章节为付费课程，如需观看，请购买'
						}).then(() => {
							console.log('用户点击确定')
						})
					}
				}
			},

			// 判断后，跳转bjy直播页面
			toBjyLivePage(id, extendStatus, chapterName, leftTimeStatus) {
				if (extendStatus == 0) { // 直播结束=回放,跳回放页面
					this.$router.push({
						'path': '/playback',
						query: {
							id: id,
							skuId: this.skuId,
							headtitle: chapterName,
							curriculumId: this.curriculumId
						}
					})
				} else if (extendStatus == 1) { // 正在直播，跳直播页
					api.get('/p/curriculum/chapterJudgeLiveOrPlayback', {
						chapterId: id
					}).then(r => {
						// r.data:3=直播，4=回放
						if (r.data == 3) {
							if (this.classType == 1) { //大班课
								api.get('/curriculum/getBjyLivePageUrl/' + id).then((res) => {
									if (res.success) {
										location.href = res.data
									} else {
										this.$toast(res.message)
									}
								})
							} else { // 小班课
								this.$dialog.alert({
									title: '提示',
									message: '该课程为小班课，手机wap端仅提供观看聊天功能，如需享受连麦发言功能，请前往PC端'
								}).then(() => {
									api.get('/curriculum/getBjyLivePageUrl/' + id).then((res) => {
										if (res.success) {
											location.href = res.data
										} else {
											this.$toast(res.message)
										}
									})
								})
							}
						} else if (r.data == 4) {
							this.$dialog.alert({
								title: '提示',
								message: '该直播已结束，观看回放'
							}).then(() => {
								this.$router.push({
									'path': '/playback',
									query: {
										id: id,
										skuId: this.skuId,
										headtitle: chapterName,
										curriculumId: this.curriculumId
									}
								})
							})
						}
					})
				} else if (extendStatus == 2) { // 直播还没开始
					// 购买了或者免费：走验证接口,只能提前30分钟进直播，data里是true是超过30分钟，false是能看的
					api.get('/broadcast/judgeMintuesByChapterId', {
						chapterId: id
					}).then((res) => {
						if (res.success) {
							if (res.data) {
								// 没到三十分钟
								this.$dialog.alert({
									title: '提示',
									message: '您来早啦，直播课提前30分钟进即可~'
								}).then(() => {
									console.log('用户点击确定')
								})
							} else {
								// 30分钟内
								api.get('/p/curriculum/chapterJudgeLiveOrPlayback', {
									chapterId: id
								}).then(r => {
									// r.data:3=直播，4=回放
									if (r.data == 3) {
										if (this.classType == 1) { //大班课
											api.get('/curriculum/getBjyLivePageUrl/' + id).then((rr) => {
												if (rr.success) {
													location.href = rr.data
												} else {
													this.$toast(rr.message)
												}
											})
										} else { // 小班课
											this.$dialog.alert({
												title: '提示',
												message: '该课程为小班课，手机wap端仅提供观看聊天功能，如需享受连麦发言功能，请前往PC端'
											}).then(() => {
												api.get('/curriculum/getBjyLivePageUrl/' + id).then((rr) => {
													if (rr.success) {
														location.href = rr.data
													} else {
														this.$toast(rr.message)
													}
												})
											})
										}
									} else if (r.data == 4) {
										this.$dialog.alert({
											title: '提示',
											message: '该直播已结束，观看回放'
										}).then(() => {
											this.$router.push({
												'path': '/playback',
												query: {
													id: id,
													skuId: this.skuId,
													headtitle: chapterName,
													curriculumId: this.curriculumId
												}
											})
										})
									}
								})
							}
						} else {
							this.$toast(res.message)
						}
					})
				}
			},

			// 显示章节对应附件列表
			toshowFiles(skuFiles, free) {
				if (this.buyOrNot) { // 买了
					this.showFiles = true
					this.skuFiles = skuFiles
				} else {
					// 没买
					if (free) {
						// 免费
						this.showFiles = true
						this.skuFiles = skuFiles
					} else {
						// 不免费
						this.$dialog.alert({
							title: '提示',
							message: '购买后才可下载附件哦~'
						}).then(() => {
							// 用户点击确定
						});
					}
				}
			},

			// 附件选择弹窗，选择附件，进行下载
			onSelectFiles(item, index) {
				this.showFiles = false;
				let url = item.filePath
				// 打开文档
				window.open(this.resourceDomain + url)
			},

			// 选择tab
			choose_tab(tab_index) {
				this.tab_index = tab_index
			},

			// listen event
			onPlayerPlay(player) {
				console.log('player play!', player)
				// 开始播放时间
				if (!this.nowTime) {
					var nowTime = util.dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss")
					this.nowTime = nowTime
				}
				// 计算时长
				this.interval = setInterval(() => {
					this.totalTime += this.intervalDur
				}, this.intervalDur)
			},
			onPlayerPause(player) {
				// 暂停
				console.log('player pause!', player)
				clearInterval(this.interval)
			},
			// 获取视频播放进度
			onPlayerTimeupdate(player) {
				this.playPosition = player.cache_.currentTime
			},
			// 设置视频进度
			playerReadied(player) {
				if (this.playPosition != 0) {
					player.currentTime(this.playPosition)
				}
				console.log("设置播放进度")
			},

			// 保存观看记录
			insertChapterViewingRecord() {
				var ths = this
				var playPosition = parseInt(this.playPosition)
				var totalTime = this.totalTime / 1000
				var playEndTime = util.dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss")
				// 观看时间超过一秒记录
				if (totalTime > 0) {
					api.postJson(`/curriculum/viewingRecord/${ths.curriculumId}/${ths.skuId}`, {
						curriculumChapterId: ths.chapterId,
						playBeginTime: ths.nowTime,
						playEndTime: playEndTime,
						playLength: totalTime,
						playPosition: playPosition,
					}).then(r => {
						this.totalTime = 0
						this.nowTime = null
						console.log("保存观看记录")
					})
				}
			},
		}
	}
</script>

<style>
	::-webkit-scrollbar {
		width: 0 !important;
	}

	::-webkit-scrollbar {
		height: 0 !important;
	}

	.vjs-big-play-button {
		background-color: unset !important;
		border: unset !important;
		font-size: 50px !important;
		color: #fff !important;
	}

	.video-js .vjs-control-bar {
		background-color: rgba(0, 0, 0, 0.5);
	}

	.vjs-volume-panel {
		display: none !important;
	}

	.curriculum_details img {
		max-width: 345px;
		width: 100%;
		display: block;
		margin: 10px 0;
		object-fit: contain;
		height: auto;
	}

	.curriculum_details p {
		margin: 0;
		margin-block-start: 0;
		margin-block-end: 0;
		line-height: 23px;
	}
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
	.top {
		position: fixed;
		left: 0;
		top: 48px;
		z-index: 999;
	}
	.curriculum_title {
		height:55px;
		padding: 0 15px;
		width: 345px;
	}

	.main_a {
		width: 375px;
		height: 187.5px;
		margin: 0 auto;
		position: relative;
		display: block;
	}

	.padding_a {
		padding: 15px 0;
	}

	.border_top_a {
		border-top: 10px solid #f5f5f5;
	}

	.tab_item {
		position: relative;
		height: 40px;
		line-height: 40px;
	}

	.active {
		color: #3b7bfd;
	}

	.active::after {
		content: "";
		width: 25px;
		height: 3px;
		background-color: #3b7bfd;
		border-radius: 1.5px;
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
	}

	.tab_content {
		position: fixed;
		z-index: 999;
		left: 0;
		right: 0;
		bottom: 0;
		height: calc(100% - 340.5px);
		overflow: scroll;
	}

	.curriculum_item {
		padding: 15px 0;
		border-bottom: 1px solid #eee;
	}

	.teachercell {
		width: 60px;
		height: 60px;
		border-radius: 50%;
		margin-right: 10px
	}

	.teacherbrief {
		padding-top: 10px;
		line-height: 20px
	}

	.cell_a {
		padding: 10px 15px;
		width: 345px;
	}

	.syllabu_item {
		padding: 15px 0;
		border-bottom: 1px solid #eee;
		position: relative;
	}

	.freeIcon {
		position: absolute;
		right: -15px;
		top: 0;
		width: 40px;
		height: 40px;
	}

	.curriculum_details {
		padding: 15px;
		width: 345px;
		line-height: 23px;
		padding-top: 10px;
	}

	.downbtn {
		padding: 0 12px;
		text-align: center;
		line-height: 24px;
		height: 24px;
		border-radius: 12px;
	}

	.margin_bottom_a3 {
		margin-bottom: 7.5px;
	}

	.livingIcon {
		width: 15px;
		height: 15px;
		margin-right: 8px;
		display: block;
	}
</style>
